// extracted by mini-css-extract-plugin
export default {"day_of_week_table":"style_day_of_week_table__M7GBS","day_td":"style_day_td__fL-vV","td_box":"style_td_box__Zr9sb","active":"style_active__vZS95"};